import {
	RECORD_USERINFO,
	LOGOUT,
} from './mutation-types.js'

import {setStore, getStore} from '../config/mUtils'

export default {
	// 登录
	[RECORD_USERINFO](state, userInfo = null) {
		if (userInfo && userInfo.token) {
			state.login = true
			setStore('userInfo', userInfo);
		} else {
			state.login = false
			setStore('userInfo', '');
		}
		state.userInfo = userInfo
	},
	// 退出登录
	[LOGOUT](state) {
		state.login = false
		setStore('userInfo', '');
	}
}